var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLostInTranslation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.9,
    y: 3.9,
    width: 14.76,
    height: 14.76,
    rx: 7.38,
    stroke: "black",
    strokeWidth: 1.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4279 6.60004C11.8711 6.60004 12.2275 6.96468 12.2174 7.40776L12.1134 11.9639C12.1049 12.3373 11.7998 12.6355 11.4263 12.6355V12.6355C11.0527 12.6355 10.7475 12.337 10.7392 11.9634L10.6384 7.40721C10.6286 6.96434 10.9849 6.60004 11.4279 6.60004V6.60004ZM11.4261 15.24C11.1729 15.24 10.9558 15.151 10.7749 14.9729C10.5969 14.7948 10.5078 14.5778 10.5078 14.3218C10.5078 14.0713 10.5969 13.8571 10.7749 13.679C10.9558 13.5009 11.1729 13.4119 11.4261 13.4119C11.6737 13.4119 11.888 13.5009 12.0689 13.679C12.2525 13.8571 12.3443 14.0713 12.3443 14.3218C12.3443 14.4915 12.3012 14.6459 12.2149 14.7851C12.1315 14.9242 12.0202 15.0355 11.881 15.119C11.7447 15.1997 11.593 15.24 11.4261 15.24Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6797 16.68L20.9997 21",
    stroke: "black",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLostInTranslation);
export default __webpack_public_path__ + "static/media/lost_in_translation.e0ce610ae024f33ddafedb2a212e9e25.svg";
export { ForwardRef as ReactComponent };